const REQUEST_VALUE_KEYS = Object.freeze({
    'dock-compound': new Set([
        'dockingProgram',
        'poseCount',
        'speedArg',
        'keepHs',
        'keepSrc3D',
    ]),
    'get-energies': new Set([
        'energyEngine',
        'forcefield',
        'residueCutoff',
        'useUnboundConf',
    ]),
    'energy-minimize': new Set([
        'minimizationType',
        'minimizationEngine',
        'energyEngine',
        'forcefield',
        'minimizationSteps',
        'residueCutoff',
        'useUnboundConf',
    ]),
});

function safeReceiptValue(value) {
    return value === null || ['string', 'number', 'boolean'].includes(typeof value);
}

export function sanitizeBfdRequestValues(requestKind, requestArgs = {}) {
    const allowedKeys = REQUEST_VALUE_KEYS[requestKind] || new Set();
    return Object.fromEntries(Object.entries(requestArgs)
        .filter(([key, value]) => allowedKeys.has(key) && safeReceiptValue(value)));
}

export function buildBfdExecutionReceipt({
    requestKind,
    requestValues = [],
    options = {},
    batchSize,
}) {
    const clientControls = {};
    if (Object.prototype.hasOwnProperty.call(options, 'skipSolvation')) {
        clientControls.skipSolvation = Boolean(options.skipSolvation);
    }
    if (batchSize !== undefined) clientControls.batchSize = batchSize;
    return {
        source: 'browser-bfd-connector-request',
        requestKind,
        requests: requestValues.map((values) => ({
            values: sanitizeBfdRequestValues(requestKind, values),
        })),
        ...(Object.keys(clientControls).length > 0 ? { clientControls } : {}),
    };
}
